export default __webpack_public_path__ + "static/N0224-d5fe2247a7cebc71a0d5e16684a184b1.png";